
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthService from "../../services/auth.service";

const errorMessage = (error) =>
    error.response?.data?.message || error.message || "Something went wrong";

// Admin Login
export const adminLogin = createAsyncThunk(
    "auth/adminLogin",
    async (credentials, thunkAPI) => {
        try {
            return await AuthService.adminLogin(credentials);
        } catch (error) {
            return thunkAPI.rejectWithValue(errorMessage(error));
        }
    }
);

// User Login
export const userLogin = createAsyncThunk(
    "auth/userLogin",
    async (credentials, thunkAPI) => {
        try {
            return await AuthService.userLogin(credentials);
        } catch (error) {
            return thunkAPI.rejectWithValue(errorMessage(error));
        }
    }
);

// Get Admin Profile
export const getProfile = createAsyncThunk(
    "auth/getProfile",
    async (_, thunkAPI) => {
        try {
            const response = await AuthService.getProfile();
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(errorMessage(error));
        }
    }
);

export const getDashboard = createAsyncThunk(
    "auth/getDashboard",
    async (_, thunkAPI) => {
        try {
            const response = await AuthService.getDashboard();

            console.log("DASHBOARD RESPONSE:", response);

            // AuthService already returns the inner dashboard object
            if (!response || typeof response !== "object") {
                return thunkAPI.rejectWithValue(
                    "Invalid dashboard response"
                );
            }

            return response;

        } catch (error) {
            console.error(
                "DASHBOARD API ERROR:",
                error.response?.data || error.message
            );

            return thunkAPI.rejectWithValue(errorMessage(error));
        }
    }
);

// Logout
export const logout = createAsyncThunk(
    "auth/logout",
    async () => {
        AuthService.logout();
        return true;
    }
);
const initialState = {
    loading: false,
    dashboardLoading: false,

    error: "",
    dashboardError: "",

    user: AuthService.getUserDetails(),
    dashboard: null,
};

const startLoading = (state) => {
    state.loading = true;
    state.error = "";
};

const failLoading = (state, action) => {
    state.loading = false;
    state.error =
        action.payload || action.error?.message || "Login failed";
};

const authSlice = createSlice({
    name: "auth",
    initialState,

    reducers: {
        clearAuthError(state) {
            state.error = "";
        },

        clearDashboardError(state) {
            state.dashboardError = "";
        },
    },

    extraReducers: (builder) => {
        builder
            // Admin Login
            .addCase(adminLogin.pending, startLoading)
            .addCase(adminLogin.fulfilled, (state, action) => {
                state.loading = false;
                state.user = action.payload;
            })
            .addCase(adminLogin.rejected, failLoading)

            // User Login
            .addCase(userLogin.pending, startLoading)
            .addCase(userLogin.fulfilled, (state, action) => {
                state.loading = false;
                state.user = action.payload;
            })
            .addCase(userLogin.rejected, failLoading)

            // Profile
            .addCase(getProfile.pending, (state) => {
                state.error = "";
            })
            .addCase(getProfile.fulfilled, (state, action) => {
                state.user = action.payload;
            })
            .addCase(getProfile.rejected, (state, action) => {
                state.error =
                    action.payload || action.error?.message;
            })

            // Dashboard
            .addCase(getDashboard.pending, (state) => {
                state.dashboardLoading = true;
                state.dashboardError = "";
            })
            .addCase(getDashboard.fulfilled, (state, action) => {
                state.dashboardLoading = false;
                state.dashboard = action.payload;
            })
            .addCase(getDashboard.rejected, (state, action) => {
                state.dashboardLoading = false;
                state.dashboardError =
                    action.payload ||
                    action.error?.message ||
                    "Failed to fetch dashboard";
            })

            // Logout
            .addCase(logout.fulfilled, (state) => {
                state.user = null;
                state.dashboard = null;
                state.error = "";
                state.dashboardError = "";
            });
    },
});

export const {
    clearAuthError,
    clearDashboardError,
} = authSlice.actions;

export default authSlice.reducer;
